import { BASE_URL } from 'configs';
import request from 'utils/axios';
import { ContentItem, ContentItemPayload, ContentItemImage } from './types';

export const CONTENT_ITEMS_URL = `${BASE_URL}/api/content-items`;

/** Open to any authenticated user (ADMIN or CONTENT_EDITOR). */
export const getContentItems = (): Promise<ContentItem[]> => request(CONTENT_ITEMS_URL, { method: 'GET', includeAuth: true });

export const getContentItem = (id: string): Promise<ContentItem> =>
  request(`${CONTENT_ITEMS_URL}/${id}`, { method: 'GET', includeAuth: true });

export const createContentItem = (payload: ContentItemPayload): Promise<ContentItem> =>
  request(CONTENT_ITEMS_URL, { method: 'POST', includeAuth: true, data: payload });

export const updateContentItem = (id: string, payload: ContentItemPayload): Promise<ContentItem> =>
  request(`${CONTENT_ITEMS_URL}/${id}`, { method: 'PATCH', includeAuth: true, data: payload });

/** JPEG/PNG only, validated server-side by magic bytes + a configured size cap. */
export const uploadContentItemImage = (id: string, file: File): Promise<ContentItemImage> => {
  const formData = new FormData();
  formData.append('file', file);
  return request(`${CONTENT_ITEMS_URL}/${id}/images`, {
    method: 'POST',
    includeAuth: true,
    autoContentType: true,
    data: formData,
  });
};

export const publishContentItem = (id: string): Promise<ContentItem> =>
  request(`${CONTENT_ITEMS_URL}/${id}/publish`, { method: 'POST', includeAuth: true });

export const unpublishContentItem = (id: string): Promise<ContentItem> =>
  request(`${CONTENT_ITEMS_URL}/${id}/unpublish`, { method: 'POST', includeAuth: true });

/**
 * Send the complete ordered list of content-item ids as arranged in the UI; the backend assigns
 * position 0..n-1 and rejects a partial list or unknown/duplicate ids (ordering is global).
 */
export const reorderContentItems = (orderedIds: string[]): Promise<ContentItem[]> =>
  request(`${CONTENT_ITEMS_URL}/reorder`, { method: 'PATCH', includeAuth: true, data: { orderedIds } });
